export default "__VITE_PUBLIC_ASSET__265306e2__"